import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {IgDashboardComponent} from "../page/dashboard/ig-dashboard.component";


const igModuleEntry: TestModuleDefinition = {
    key: 'ig',
    label: 'Access Token (ig)',
    components: [
        {
            key: 'IgDashboardComponent',
            component: IgDashboardComponent,
            selector: 'mvs-ig-dashboard',
            type: 'PageComponent',
            label: 'ig dashboard component'
        }
    ]
}

export const IG_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: igModuleEntry, multi: true}
];